<script setup>
    import { computed } from 'vue';
    import useCurrentLocale from "@Common/Composables/current-locale";
    import { trackData } from "@Helpers/trackData";

    const props = defineProps({
        href: {type: String, default: '', required: true},
        target: {type: String, default: ''},
        trackEvent: {type: String, default: ''},
        trackAction: {type: String, default: ''},
        external: {type: Boolean, default: false},
        title: {type: String, default: ''}
    });

    function track() {
        if (props.trackEvent) {
            const event = {event: props.trackEvent};
            if (props.trackAction) {
                event.action = props.trackAction;
            }
            trackData(event);
        }
    }

    const { urlWithLocale } = useCurrentLocale();
    const localizedHref = computed(() => (props.href) ? urlWithLocale.value(props.href) : '');
</script>
<template>
    <a class="y-inline-flex y-items-center y-gap-1" :href="localizedHref" :target="target" :title="title" @click="track">
        <span v-if="external" class="yapla-icon icon-external-link"></span>
        <slot/>
    </a>
</template>